module.exports = __webpack_public_path__ + "static/logo-9d23dddcf2693d85034a066e17c4f22b.png";